
















































































import {
  defineComponent, ref, onMounted, getCurrentInstance,
} from 'vue';
import { env } from '@hb/mbridge';
import { navigateTo, versionCompare } from '~mall/common/utils/rentUtils';
import { QueryCouponGoodsProductDetailList } from '~mall/model/apis/ticketApis';
import { Tag, QueryCouponGoodsProductDetailListRsp, Product } from './QueryCouponGoodsProductDetailList.d';

export default defineComponent({
  name: 'RentCouponCard',
  setup() {
    const instance = getCurrentInstance();
    // 非空断言（或根据项目规范加判空）
    const route = instance!.proxy!.$route;
    const products = ref<Product[]>([]);
    const isShowAllProduct = ref(false);

    const showColor2BgColor = (color: string) => {
      const lists: Record<string, { color: string; background: string }> = {
        yellow: {
          color: '#C99E67',
          background: '#FFF8EF',
        },
        red: {
          color: '#F25656',
          background: '#FEF6F6',
        },
        white: {
          color: '#5a6066',
          background: '#bcc4cc',
        },
      };
      return lists[color.toLowerCase()];
    };

    const setStyle = (tag: Tag) => {
      if (tag.showColor) {
        return showColor2BgColor(tag.showColor);
      }
      return {};
    };

    const jumpToModelDetail = (productId?: string) => {
      if (!productId) return;
      navigateTo({
        miniPath: `/pages/modelDetail/index?modelId=${productId}`,
        appPath: `hellobike://hellobike.com/new_detail?modelId=${productId}&type=2`,
      });
    };

    const goToHome = () => {
      navigateTo({
        miniPath: '/pages/homepage/index',
        appPath: 'hellobike://hellobike.com/evehicle/shop',
      });
    };

    onMounted(() => {
      const spuId = route.query.spuId as string;
      QueryCouponGoodsProductDetailList({
        ids: [spuId],
      }).then((res: QueryCouponGoodsProductDetailListRsp) => {
        if (!res || !res.products) return;
        products.value = res.products;
        if (res.isShowAllProduct) {
          let isShowRentModule = true;
          if (env.isEasyBikeApp && versionCompare(env.appVersion, '6.16.0') < 0) {
            isShowRentModule = false;
          }
          isShowAllProduct.value = isShowRentModule;
        }
      });
    });

    return {
      products,
      isShowAllProduct,
      setStyle,
      jumpToModelDetail,
      goToHome,
    };
  },
});
